/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_Label_TitleInputs */

const en_story_bank_label_title = /** @type {(inputs: Story_Bank_Label_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title`)
};

const de_story_bank_label_title = /** @type {(inputs: Story_Bank_Label_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title`)
};

const fr_story_bank_label_title = /** @type {(inputs: Story_Bank_Label_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title`)
};

const es_story_bank_label_title = /** @type {(inputs: Story_Bank_Label_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title`)
};

const it_story_bank_label_title = /** @type {(inputs: Story_Bank_Label_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title`)
};

const nl_story_bank_label_title = /** @type {(inputs: Story_Bank_Label_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title`)
};

const pl_story_bank_label_title = /** @type {(inputs: Story_Bank_Label_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title`)
};

const fi_story_bank_label_title = /** @type {(inputs: Story_Bank_Label_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title`)
};

const da_story_bank_label_title = /** @type {(inputs: Story_Bank_Label_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title`)
};

const sv_story_bank_label_title = /** @type {(inputs: Story_Bank_Label_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title`)
};

/**
* | output |
* | --- |
* | "Title" |
*
* @param {Story_Bank_Label_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_label_title = /** @type {((inputs?: Story_Bank_Label_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_Label_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_label_title(inputs)
	if (locale === "fr") return fr_story_bank_label_title(inputs)
	if (locale === "es") return es_story_bank_label_title(inputs)
	if (locale === "it") return it_story_bank_label_title(inputs)
	if (locale === "nl") return nl_story_bank_label_title(inputs)
	if (locale === "pl") return pl_story_bank_label_title(inputs)
	if (locale === "fi") return fi_story_bank_label_title(inputs)
	if (locale === "da") return da_story_bank_label_title(inputs)
	if (locale === "sv") return sv_story_bank_label_title(inputs)
	return en_story_bank_label_title(inputs)
});